export default "__VITE_ASSET__Ch5e_o6y__"